export const getDadosDashboard = (state) => state.dashboard.dados
export const getIsCarregandoDadosDashboard = (state) => state.dashboard.isCarregandoDados
export const getAnoCarregado = (state) => state.dashboard.anoCarregado
export const getUnidadeCarregada = (state) => state.dashboard.unidadeCarregada
